import middleware from './middleware'
import reducer from './reducer'

export * from './provider'

export const connectedRouter = { middleware, reducer }

export default connectedRouter
